import getElementSelectors from '../shares/lib/getElementSelectors';
import { SelectedGame } from '../shares/types/SwipeSDKConfigType';

export const changeSwipeGameIcon = (classList: SelectedGame): void => {
  const { swipeControlItem, dropdownToggle } = getElementSelectors();

  if (!swipeControlItem) return;

  const swipeControlClasses = Array.from(swipeControlItem.classList);
  swipeControlClasses.forEach((className) => {
    if (className.startsWith('game_icon_')) {
      swipeControlItem.classList.remove(className);
    }
  });

  if (classList.currentGameId) {
    swipeControlItem.classList.add(`game_icon_${classList.currentGameId}`);
  }

  if (!dropdownToggle) return;
  dropdownToggle.setAttribute('data-game-id', classList?.currentGameId || '');

  if (classList.previousGameId) {
    dropdownToggle.classList.remove(`game_${classList.previousGameId}`);
  }

  if (classList.currentGameId) {
    dropdownToggle.classList.add(`game_${classList.currentGameId}`);
  }
};

export default changeSwipeGameIcon;
